import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {navigateToRoute} from '~/CreateFabricInvitation/navigation';
import {selectIsPremium} from '~/common/FabricInvitation/reducers/fabricTemplate/selectors';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';

export const useNavigation = ({
  store,
  canvas,
  currentRoute,
  usedPremiumFeature,
  premiumFeaturesPristine,
  handleShowUpsell,
}) => {
  const dispatch = useDispatch();
  const isPremium = useSelector(selectIsPremium);

  const stopSubmitting = useCallback(() => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {savingStep: false},
    });
  }, [dispatch]);

  const continueNavigation = useCallback(async () => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {savingStep: true},
    });

    let navigating = true;

    try {
      navigating = await navigateToRoute(currentRoute.nextRoute, store, false, false, [canvas]);
    } catch (e) {
      navigating = false;
      evite.error('Failed to navigate', e);
    } finally {
      if (!navigating) {
        stopSubmitting();
      }
    }
  }, [canvas, store, currentRoute, dispatch, stopSubmitting]);

  const handleNavigation = useCallback(async () => {
    if (!isPremium && (usedPremiumFeature || !premiumFeaturesPristine)) {
      handleShowUpsell();
      return;
    }

    await continueNavigation();
  }, [
    continueNavigation,
    premiumFeaturesPristine,
    usedPremiumFeature,
    isPremium,
    handleShowUpsell,
  ]);

  return {
    handleNavigation,
    continueNavigation,
    stopSubmitting,
  };
};
